import { Injectable } from '@angular/core';
import { User_default_user_get_collection_user_get_item } from '../../api_types';
import { UserAccountInterface, UserService } from '@hutsix/ngxh6';

/**
 * Service for managing user data.
 */
@Injectable()
export class MacUserService extends UserService {
    public account?: MacUserAccount;

    set default_community_and_staff(value: any) {
        this.account.default_community_and_staff = value;
        this.saveUserData();
    }

    get default_community_and_staff(): any {
        return this.account?.default_community_and_staff;
    }

    // Fallback object guards against the brief window after login where `loggedIn` is true
    // but `account.user` hasn't been populated yet, which otherwise crashes callers reading
    // `.id`/`.roles`/`.communities`. The empty `id` won't match real user IRIs.
    get user(): User_default_user_get_collection_user_get_item {
        return this.account?.user ?? { id: '', roles: [], firstName: null, lastName: null, communities: [] };
    }

    // Same guard as the `user` getter above: a sync can be triggered (auto-sync on offline
    // state change, or the dashboard sync button) during the window where `account` isn't
    // populated yet. The base setter throws 'Account not defined' in that case, so no-op
    // instead — there is no account data to lock. Both accessors are overridden together so
    // the inherited getter isn't lost when only the setter is redefined.
    get offline_lock(): boolean {
        return this.account?.offline_lock ?? false;
    }

    set offline_lock(value: boolean) {
        if (!this.account) return;
        this.account.offline_lock = value;
        this.saveUserData();
    }

    get list_communities(): any {
        return this.user.communities?.map(comm => comm.id) ?? [];
    }
}

export class MacUserAccount implements UserAccountInterface {
    meta: any = {};
    token?: string;
    refresh_token?: string;
    offline_lock: boolean = false;
    user: User_default_user_get_collection_user_get_item;
    simulating_offline: boolean = false;
    impersonating?: string;
    email?: string;
    sync_date?: number;
    default_community_and_staff?: any = null;
}
